(function() {
  // Skip on touch devices
  if ('ontouchstart' in window) return;

  function initTilt() {
    document.querySelectorAll('.product-card').forEach(function(card) {
      card.style.transformStyle = 'preserve-3d';
      card.style.willChange = 'transform';

      var imageWrap = card.querySelector('.product-card__image-wrap');

      card.addEventListener('mousemove', function(e) {
        if (typeof gsap === 'undefined') return;
        var b = card.getBoundingClientRect();
        var posX = (e.clientX - b.left) / b.width;
        var posY = (e.clientY - b.top) / b.height;
        var rotX = (0.5 - posY) * 20;
        var rotY = (posX - 0.5) * 20;

        gsap.to(card, { rotateX: rotX, rotateY: rotY, transformPerspective: 1000, duration: 0.5, ease: 'power2.out' });

        // Specular light follows cursor
        if (imageWrap) {
          imageWrap.style.backgroundImage =
            'radial-gradient(circle at ' + (posX * 100) + '% ' + (posY * 100) + '%, rgba(201,168,76,0.15), transparent 70%)';
        }
      });

      card.addEventListener('mouseleave', function() {
        if (typeof gsap === 'undefined') return;
        gsap.to(card, { rotateX: 0, rotateY: 0, duration: 0.7, ease: 'power2.out' });
        if (imageWrap) {
          imageWrap.style.backgroundImage = '';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTilt);
  } else {
    initTilt();
  }
})();
